// src/common/data/getTypeSubcategoryFromCategory.ts

import { ITEM_TYPES } from './itemTypes3';

/**
 * Given a raw type_category, return the unique list of associated type_subcategory (raw, untranslated).
 */
export const getTypeSubcategoryFromCategory = (
  typeCategory: string
): Array<{ raw: string }> => {
  const matches = ITEM_TYPES.filter(
    (item) => item.type_category === typeCategory
  );

  const subcategories = matches.map((item) => ({
    raw: item.type_subcategory,
  }));

  // Deduplicate by raw value
  const seen = new Set<string>();
  const uniqueSubcategories = subcategories.filter(({ raw }) => {
    if (seen.has(raw)) return false;
    seen.add(raw);
    return true;
  });

  return uniqueSubcategories;
};
